import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c09e69f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role-page" }
const _hoisted_2 = { class: "ws_common_operation ws_mt20 ws_mr20" }
const _hoisted_3 = { class: "list ws_common_table" }

import { onMounted, ref, computed } from 'vue'
import i18n from '@/i18n'
import { PAGE_SIZES, CODE_ENUM, STATUS_TYPE } from '@/common'
import { queryRolePage, updateRoleStatus, deleteRoleInfo } from '@/api'
import moment from 'moment'
import RoleForm from './components/role-form-drawer.vue'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox, downLoadFile } from '@/utils'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const authStore = useAuthStore()

const isSuperAdmin = computed(() => {
  return authStore.isSuperAdmin
})
const t = i18n.global.t

const getButtonList = ({ roleStatusCode, isSuperAdmin }: any) => {
  return isSuperAdmin
    ? []
    : [
        {
          type: 'config',
          text:
            roleStatusCode === STATUS_TYPE.ROLE_START
              ? t('CONFIG.rclose')
              : t('CONFIG.ropen'),
        },
        {
          type: 'edit',
          text: t('CONFIG.redit'),
        },
        {
          type: 'delete',
          text: t('CONFIG.rdelete'),
        },
      ]
}

const tableData: any = ref([{}])
const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}

const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  tableLoading.value = true

  const res: any = await queryRolePage({
    ...pageParams.value,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const toConfig = async ({ roleStatusCode, id }: any) => {
  const res: any = await updateRoleStatus({
    roleId: id,
    startOrStopCode:
      roleStatusCode === STATUS_TYPE.ROLE_START
        ? STATUS_TYPE.ROLE_STOP
        : STATUS_TYPE.ROLE_START,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    fetchList()
  }
}

const formConf = ref({
  visible: false,
  data: {},
})

const toForm = (data = {}) => {
  formConf.value = {
    visible: true,
    data,
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: t('CONFIG.rdelTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteRoleInfo({ roleIds: [id] })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(isSuperAdmin))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toForm())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.rnew')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          stripe: ""
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, {
              description: _ctx.$t('CONFIG.noData')
            }, null, 8, ["description"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.$t('CONFIG.rname'),
              "show-overflow-tooltip": ""
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: _ctx.$t('CONFIG.rtime'),
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scoped) => [
                _createTextVNode(_toDisplayString(_unref(moment)(scoped.row.createTime).format('YYYY-MM-DD HH:mm:ss')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: _ctx.$t('CONFIG.rstatus'),
              width: "200"
            }, {
              default: _withCtx((scoped) => [
                (_unref(STATUS_TYPE).ROLE_START === scoped.row.roleStatusCode)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scoped.row.roleStatusValue), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scoped.row.roleStatusValue), 1)
                      ]),
                      _: 2
                    }, 1024))
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(isSuperAdmin))
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: "operation",
                  label: _ctx.$t('CONFIG.roperation'),
                  width: "360"
                }, {
                  default: _withCtx((scoped) => [
                    _createVNode(_unref(OperationButtonList), {
                      buttonList: getButtonList(scoped.row),
                      scope: scoped.row,
                      onOnConfig: toConfig,
                      onOnEdit: toForm,
                      onOnDelete: toDelete
                    }, null, 8, ["buttonList", "scope"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(RoleForm, {
      visible: formConf.value.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((formConf.value.visible) = $event)),
      data: formConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})